<template>
  <div class="">

    <div class="container pt-3 m-auto text-left ">
      <h1>Docente Masivo</h1>
       <hr>
      <form
        autocomplete="off"
        class="form-horizontal"
        @submit.prevent="validateBeforeSubmit"
      >
        <div>
          <strong>Estructura:</strong><br>
          <span style="font-size: 10px">"primer_nombre,segundo_nombre,primer_apellido,segundo_apellido,tipo_documento,numero_documento,telefono,movil,email,sede_id"</span>
          <textarea class="area-masivo" v-model="datos"></textarea>

        </div>
        <button class="btn btn-block btn-danger" type="submit">Procesar</button>
        <div>{{ resultado}}</div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'DocenteMasivo',
    data () {
      return {
          datos: null,
          resultado: null
      }
    },
    mounted () {
    },
    methods:{
      ...mapActions({
        procesar: 'docentes/crearMasivo',
        setWarning: 'setWarning',
        fetchLista: 'docentes/fetchLista',
      }),
      ...mapMutations({
      }),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(result => {

          let lines = this.datos.split("\n");
          let candidatos = []
          for(let i in lines){
            let line = lines[i];
            let parametros = line.split(",")
            let candidato = {
              primer_nombre:parametros[0],
              segundo_nombre:parametros[1],
              primer_apellido:parametros[2],
              segundo_apellido:parametros[3],
              tipo_documento:parametros[4],
              numero_documento:parametros[5],
              telefono:parametros[6],
              movil:parametros[7],
              email:parametros[8],
              sede_id:parametros[9],
            }
            candidatos.push(candidato)
          }

          console.log(candidatos)
          if ( ! result) {
            //hay errores
          } else {
            
            this.procesar(candidatos).then((response)=>{
                this.resultado = response.message
                this.setWarning(response.message, { root: true }).then(()=>{
                this.fetchLista().then(()=>{
                    //this.$router.push('/docentes')
                })
              })
            }).catch(error=>{
              
            })
            
          }
        })
      },

    },
    computed:{
      ...mapState({
        warning: state => state.warning
      }),
    }
  }
</script>

<style scope>
  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
  .area-masivo{
    width: 100%;
  }
</style>